module.exports = __webpack_public_path__ + "media/order_create_2.47dc5fd3.mp3";